module.exports = require("./nl-SR.d.ts");